import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";

const LOGO_URL = "/images/logo.png";

function formatDetail(detail) {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return "Login failed. Please try again.";
}

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-surface flex items-center justify-center px-6">
      <div className="w-full max-w-md bg-white border border-ink/10 p-10">
        <div className="bg-white inline-block mb-8">
          <img src={LOGO_URL} alt="Obrigado PH Holdings" className="h-12 w-auto mix-blend-multiply" />
        </div>
        <h1 className="font-display font-semibold text-3xl tracking-tight text-ink" data-testid="admin-login-heading">Admin Sign In</h1>
        <p className="text-sm text-slate-500 mt-2">Access the enquiries dashboard.</p>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <label htmlFor="admin-email" className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500 block mb-2">Email</label>
            <input
              id="admin-email"
              data-testid="admin-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-white border border-ink/15 px-4 py-3.5 text-base focus:outline-none focus:border-chrome transition-colors duration-300"
              placeholder="admin@obrigadoph.co.za"
            />
          </div>
          <div>
            <label htmlFor="admin-password" className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500 block mb-2">Password</label>
            <input
              id="admin-password"
              data-testid="admin-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-white border border-ink/15 px-4 py-3.5 text-base focus:outline-none focus:border-chrome transition-colors duration-300"
              placeholder="••••••••"
            />
          </div>
          {error && <p data-testid="admin-login-error" className="text-sm text-red-600">{error}</p>}
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-ink text-paper font-mono text-[11px] uppercase tracking-[0.2em] px-8 py-4 hover:bg-chrome disabled:opacity-50 transition-colors duration-300"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
        <Link data-testid="admin-back-home" to="/" className="block mt-6 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500 hover:text-chrome transition-colors duration-300">
          ← Back to site
        </Link>
      </div>
    </div>
  );
}
